import { RecentSearchModel } from '@recent-searches/entities/recent-search';

export const recentSearchesFeatureName = 'recentSearchesModuleState';

export type RecentSearchesModuleState = Readonly<{
  recentSearches: RecentSearchModel[]
}>;
